import { GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { addTaasLoadingActions } from './addTaasLoadingActions.util';
import { addTaasUpdateAppErrorHandling } from './addTaasUpdateAppErrorHandling';

export function* watchKooperationsNachlassChanged() {
  // eSign feature removed — no ESIGN_RESET trigger
}

export const updateAppActionsGenerator = () => {
  return [new GlobalActions().checkValidityAktionsNachlassCode()];
};

export const handleKooperationsNachlassChange = addTaasLoadingActions(
  addTaasUpdateAppErrorHandling(updateAppActionsGenerator),
);
